'use client';

import PlpContainer from 'app/components/PlpContainer';
import { BasePageProps } from 'types/common';

export interface PlpSolutionPageProps extends BasePageProps {
  categoryId: string;
}

const PlpSolutionPage = (props: PlpSolutionPageProps) => (
  <>
    <PlpContainer categoryTree="solutions" {...props} />
  </>
);

export default PlpSolutionPage;
